import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';

//- Actions
export const fetchCheckTokenFailed = createAction('FETCH_CHECK_TOKEN_FAILED');
export const fetchCheckTokenSuccess = createAction('FETCH_CHECK_TOKEN_SUCCESS');
export const fetchCheckToken = createAction(
    'FETCH_CHECK_TOKEN',
    (token) => Api.getUserDataByToken(token),
    () => ({
        apiCall: true,
        onSuccess: fetchCheckTokenSuccess,
        onFail: fetchCheckTokenFailed
    })
);

export const fetchCheckEmailAvailabilityFailed = createAction('FETCH_CHECK_EMAIL_AVAILABILITY_FAILED');
export const fetchCheckEmailAvailabilitySuccess = createAction('FETCH_CHECK_EMAIL_AVAILABILITY_SUCCESS');
export const fetchCheckEmailAvailability = createAction(
    'FETCH_CHECK_EMAIL_AVAILABILITY',
    (email) => Api.checkEmailAvailability(email),
    () => ({
        apiCall: true,
        onSuccess: fetchCheckEmailAvailabilitySuccess,
        onFail: fetchCheckEmailAvailabilityFailed
    })
);

//- State
const initialState = {
    isActualToken: null,
    isEmailAvailable: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({

    FETCH_CHECK_TOKEN: (state) => {
        return { ...state, isActualToken: null, error: null, fetching: true };
    },
    FETCH_CHECK_TOKEN_FAILED: (state, action) => {
        return { ...state, isActualToken: false, error: action.payload, fetching: false };
    },
    FETCH_CHECK_TOKEN_SUCCESS: (state) => {        
        return { ...state, isActualToken: true, error: null, fetching: false };
    },
    FETCH_CHECK_EMAIL_AVAILABILITY: (state) => {
        return { ...state, isEmailAvailable: null, error: null, fetching: true };
    },
    FETCH_CHECK_EMAIL_AVAILABILITY_FAILED: (state, action) => {
        return { ...state, isEmailAvailable: false, error: action.payload, fetching: false };
    },
    FETCH_CHECK_EMAIL_AVAILABILITY_SUCCESS: (state) => {        
        return { ...state, isEmailAvailable: true, error: null, fetching: false };
    }
}, initialState);

//- Selectors
export const getTokenCheck = state => state.tokenCheck;

export const isLoading = state => getTokenCheck(state).fetching;

export const isActualToken = state => getTokenCheck(state).isActualToken;

export const isEmailAvailable = state => getTokenCheck(state).isEmailAvailable;


// WEBPACK FOOTER //
// ./src/reducers/common/tokenCheck.js